import { Http } from "./Http";

export const createReconciliation = (payload) => {
  return Http.post("inventory-reconciliations", payload);
};

export const listReconciliations = (status) => {
  const qs = status ? `?Status=${encodeURIComponent(status)}` : "";
  return Http.get(`inventory-reconciliations${qs}`);
};

export const getReconciliation = (id) => {
  return Http.get(`inventory-reconciliations/${id}`);
};

export const updateReconciliationItems = (id, items) => {
  return Http.put(`inventory-reconciliations/${id}/items`, { items });
};

export const closeReconciliation = (id) => {
  return Http.post(`inventory-reconciliations/${id}/close`, {});
};

export const cancelReconciliation = (id) => {
  return Http.post(`inventory-reconciliations/${id}/cancel`, {});
};

export const getReconciliationReport = (id) => {
  return Http.get(`inventory-reconciliations/${id}/report`);
};
